import React from 'react';
import { Button } from '../providers/harmony-scope/lazy-enablers';

interface IProps {
  text: string;
}

const markdownLinkPattern = /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g;

export const MarkdownLinkText = ({ text }: IProps) => {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  text.replace(markdownLinkPattern, (match, label, url, offset) => {
    if (offset > lastIndex) {
      parts.push(text.slice(lastIndex, offset));
    }

    parts.push(
      <Button key={`${label}-${url}-${offset}`} href={url} appearance="link" target="_blank" external>
        {label}
      </Button>
    );
    lastIndex = offset + match.length;
    return match;
  });

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return <>{parts.length > 0 ? parts : text}</>;
};
